import { Theme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';

import { pprBorderColorA, textGrayB } from "../../DashStyleGuides";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    border: `1px solid ${pprBorderColorA}`,
    borderRadius: 12,
    height: 300,
  },
  title: {
    flex: "1 1 100%",
    fontWeight: "bold",
    fontFamily: "Manrope",
    fontSize: 16,
    color: textGrayB,
  },
  tblRoot: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    height: 34,
  },
  bxFlexGrow: {
    flexGrow: 1,
  },
  quotesPerformedWrapStyles: {
    position: "relative",
    height: 200,
    padding: "0 16px",
  },
  forceTextAlign: {
    "& .MuiTableCell-head": {
      textAlign: "flex-start !important",
    },
  },
}));
